<script lang="ts">
	import type { Snippet } from "svelte";
	import type { HTMLFormAttributes } from "svelte/elements";
	import { handleInvalidInputs } from "./handleInvalidInputs.js";

	let {
		this: form,
		/* eslint-disable prefer-const */
		children,
		...rest
		/* eslint-enable prefer-const */
	}: {
		this?: HTMLFormElement;
		children: Snippet;
	} & HTMLFormAttributes = $props();
</script>

<form bind:this={form} use:handleInvalidInputs {...rest}>
	{@render children()}
</form>
